<footer class="footer-style-one"
        style="background: url('/assets/images/about.png') no-repeat;">

  <div class="footer-p-2">
    <div class="container">
      <div class="row">
        <!-- Col #1 -->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="footer-col">
            <h3>¿QUIENES SOMOS?</h3>
            <p>
              Somos el <b>primer</b> centro de artes marciales de Trujillo.
              Desde 1991, nos hemos dedicado a brindar la <b>enseñanza
                tradicional y deportiva</b> de las artes marciales de Tae
              Kwon Do y Muay Thai, así como cursos de defensa
              personal, MMA y Combat Sambo. Nuestra experiencia
              nos ha permitido enseñar tanto a civiles como a
              <b>personal militar y seguridad ciudadana</b>.
            </p>
            <ul class="social-media">
              <li><a target="_blank"
                   href="https://www.facebook.com/TigerZenDo/"><i class="fa-brands fa-facebook-f"></i></a></li>
              <li><a target="_blank"
                   href="https://x.com/tigerzendo"><i class="flaticon-twitter"></i></a></li>
              <li><a target="_blank"
                   href="https://www.instagram.com/tigerzendo/"><i class="flaticon-instagram"></i></a></li>
            </ul>
          </div>
        </div>
        <!-- Col #2 -->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="footer-col">
            <h3>¡Conéctate con Nosotros!</h3>
            <ul>
              <li>
                <i class="flaticon-maps"></i>
                <p>Calle Los Granados 229, Urb. California, Trujillo (Sede Principal)</p>
              </li>
              <li>
                <i class="flaticon-maps"></i>
                <p>Av. América Sur 1418 - Piso B, Urb. Palermo, Trujillo</p>
              </li>
              <li>
                <i class="flaticon-iphone"></i>
                <p>
                  <a href="tel:(+51)958316491">Llámanos: (+51) 958 316 491</a>
                </p>
              </li>
              <li>
                <i class="fa-brands fa-whatsapp"></i>
                <p>
                  <a href="https://wa.me/51958316491">Escríbenos: (+51) 958 316 491</a>
                </p>
              </li>
              <li>
                <i class="flaticon-mail"></i>
                <p>
                  <a href="mailto:artesmarcialestigerzendo@gmail.com">artesmarcialestigerzendo&#64;gmail.com</a>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <!-- Col #3 -->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="footer-col">
            <h3>Soporte y Ayuda: ¡Te Escuchamos!</h3>
            <ul>
              <li>
                <i class="fa-solid fa-handshake-angle"></i>
                <p>
                  <a [routerLink]="['/avisos-legales']">Avisos Legales</a>
                </p>
              </li>
              <li>
                <i class="fa-solid fa-question"></i>
                <p>
                  <a [routerLink]="['/preguntas-frecuentes']">Preguntas Frecuentes</a>
                </p>
              </li>
              <li>
                <i class="fa-solid fa-book"></i>
                <p>
                  <a [routerLink]="['/libro-de-reclamaciones']">Libro de Reclamaciones</a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-p-3 rights">
    <div class="container">
      <div class="row">
        <div class="footer-col">
          <p>
            Tiger Zen Do <i class="fa-solid fa-copyright"></i> 2025
            Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
